// **********************************************************
// Protect Us Slider Work
// **********************************************************
const protectUsSlider = document.querySelectorAll('[data-slider="protect-us-slider"]');
if (protectUsSlider.length > 0) {
  const protectUsSliderInstances = [];

  // Product Main Slider
  const protectUsSliderOptions = {
    slidesPerView: 'auto',
    spaceBetween: 8,
    speed: 600,
    freeMode: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      767: {
        spaceBetween: 20,
      },
      1023: {
        freeMode: false,
        allowTouchMove: false,
        spaceBetween: 0,
      },
    },
  };

  protectUsSlider.forEach((el) => {
    const protectUsSliderParent = el.closest('.protect-us');
    const paginationElement = protectUsSliderParent.querySelector('.swiper-pagination');
    protectUsSliderOptions.pagination.el = paginationElement;

    if (windowWidth() >= breakpointMd) {
      protectUsSliderOptions.effect = 'fade';
      protectUsSliderOptions.fadeEffect = {
        crossFade: true,
      };
    }

    const sliderInstance = new Swiper(el, protectUsSliderOptions);
    protectUsSliderInstances.push(sliderInstance);
  });

  const closeAllAccordions = (parentElement) => {
    const allAccordions = parentElement.querySelectorAll('.protect-us__accordion-item');
    allAccordions.forEach((accordion) => {
      accordion.classList.remove('is-open');
      closeAccordion(accordion.querySelector('.protect-us__accordion-text'));
    });
  };

  // **********************************************************
  // Protect Us Animations
  // **********************************************************

  const protectUs = document.querySelectorAll('.protect-us');
  let controllerProtectUs = null;
  controllerProtectUs = new ScrollMagic.Controller();

  const initStickyElementScene = (element, parent, duration, startPoint) => {
    const accordion = parent.querySelector('.protect-us__accordion');
    const moveAccordion = new TimelineMax();

    moveAccordion.to(accordion, 1, { y: '-50%', ease: Power2.easeInOut });

    // Sticky scene
    new ScrollMagic.Scene({
      triggerElement: startPoint,
      duration: `${duration}%`,
      triggerHook: 0,
    })
      .setPin(element)
      .setTween(moveAccordion)
      // .addIndicators({ name: 'Sticky' })
      .addTo(controllerProtectUs);
  };

  const openAccordion = (element) => {
    gsap.to(element, { height: 'auto', duration: 0.3 });
  };

  const closeAccordion = (element) => {
    gsap.to(element, { height: '0', duration: 0.3 });
  };

  const toggleItems = (element, toggle, i) => {
    element[i].classList.toggle('is-open', toggle);
  };

  const initEachSlideScene = (fakeSlides, accordion, sliderInstance, parentElement) => {
    fakeSlides.forEach((slideElem, i) => {
      new ScrollMagic.Scene({
        triggerElement: slideElem,
        duration: slideElem.clientHeight,
        triggerHook: 0,
      })
        .on('enter', (e) => {
          const content = accordion[i].querySelector('.protect-us__accordion-text');

          if (e.scrollDirection === 'FORWARD' && i >= 0) {
            toggleItems(accordion, true, i);
            openAccordion(content);
          }

          if (e.scrollDirection === 'REVERSE' && i < accordion.length) {
            closeAllAccordions(parentElement);
            toggleItems(accordion, true, i);
            openAccordion(content);
          }

          sliderInstance.slideTo(i, 800);
        })
        .on('leave', (e) => {
          const content = accordion[i].querySelector('.protect-us__accordion-text');

          if (e.scrollDirection === 'FORWARD' && i < accordion.length - 1) {
            closeAllAccordions(parentElement);
            toggleItems(accordion, false, i);
            closeAccordion(content);
          }

          if (e.scrollDirection === 'REVERSE' && i > 0) {
            toggleItems(accordion, false, i);
            closeAccordion(content);
          }

          sliderInstance.slideTo(i, 800);
        })
        // .addIndicators({ name: `slide ${i}` })
        .addTo(controllerProtectUs);
    });
  };

  const initEntryScene = (parentElement) => {
    // Sticky scene
    new ScrollMagic.Scene({
      triggerElement: parentElement,
      duration: 300,
      triggerHook: 0.5,
    })
      .on('enter', () => {
        parentElement.classList.add('is-animated');
      })
      // .addIndicators({ name: 'entry' })
      .addTo(controllerProtectUs);
  };

  const initAllScenes = () => {
    protectUs.forEach((el, index) => {
      const parentElement = el.closest('.sc-protect-us');
      const stickyElement = parentElement.querySelector('.protect-us__body-inner');
      const fakeSlides = parentElement.querySelectorAll('.protect-us__faker-slide');
      const fakeSlidesWrapper = parentElement.querySelector('.protect-us__faker-slides');
      // const duration = parentElement.querySelectorAll('.protect-us__slider-slide').length * 100;
      const startPoint = parentElement.querySelector('.protect-us__animation-start');
      const accordion = parentElement.querySelectorAll('.protect-us__accordion-item');

      initStickyElementScene(stickyElement, parentElement, `${fakeSlidesWrapper.clientHeight}px`, startPoint);
      initEachSlideScene(fakeSlides, accordion, protectUsSliderInstances[index], parentElement);
      initEntryScene(parentElement);
    });
  };

  const handleResize = () => {
    initializeOrDestroyScrollMagic(controllerProtectUs, initAllScenes);
  };

  if (windowWidth() >= breakpointMd) {
    initAllScenes();
  }

  window.addEventListener('resize', handleResize);

  const protectUsElements = document.querySelectorAll('.protect-us');

  protectUsElements.forEach((el, index) => {
    el.setAttribute('data-index', index);
  });

  attachEvent('.protect-us__accordion-title', 'click', (ev) => {
    const parentElem = ev.target.closest('.protect-us');
    const allAccordions = Array.from(parentElem.querySelectorAll('.protect-us__accordion-item'));
    const accordionItem = ev.target.closest('.protect-us__accordion-item');
    const clickedIndex = allAccordions.indexOf(accordionItem);
    const parentIndex = parentElem.getAttribute('data-index');
    const fakeSlides = parentElem.querySelectorAll('.protect-us__faker-slide');
    const clickedFakeSlide = fakeSlides[[clickedIndex]];

    if (accordionItem && !accordionItem.classList.contains('is-open')) {
      accordionItem.classList.add('is-open');
      protectUsSliderInstances[parentIndex].slideTo(clickedIndex, 800);
      const elementRect = clickedFakeSlide.getBoundingClientRect();
      const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const topOffset = elementRect.top + scrollTop + 10;
      window.scrollTo({
        top: topOffset,
        behavior: 'smooth',
      });
    }
  });
}
